import { request } from "../utils/request";
import { getCookie } from "../utils/utils";

export default{
    getMyTickets:async(payload)=>{
        return request.get(`/my-tickets`,{params: payload});
    },
    getTicketsByConfirmationID:async(payload)=>{
        return request.get("/tickets-by-confirmationid",{params:payload});
    }
}
